<template>
    <div class="row">
        <div class="column">
            <h1>Pagina niet gevonden!</h1>
        </div>
    </div>
</template>

<script>
export default {

}
</script>